import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { reduxForm, formValueSelector } from 'redux-form';
import { getFormValues } from 'redux-form/immutable';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  Collapse,
} from 'react-bootstrap';

import { find, first, delay } from 'lodash';
import Fa from 'react-fontawesome';
import styles from './styles.css';

// Import Selectors
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { requestUpdateOrganization } from '../../../Admin/AdminActions';
import {
  allContactGDPROptions,
  allSalesRepGDPROptions,
} from '../../../../util/helpers';

class SalesGoalsPage extends Component {
  constructor () {
    super();
    this.state = {};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectSalesGoals = this.selectSalesGoals.bind(this);
    this.selectSalesManagerSelection = this.selectSalesManagerSelection.bind(
      this,
    );
  }

  componentWillMount () {
    if (this.props.pristine) {
      this.initData();
    }
  }

  initData () {
    const { organization } = this.props;
    if (organization) {
      this.props.change(
        'annual_sales_goals',
        organization.annual_sales_goals || false,
      );
      this.props.change(
        'sales_manager_selection',
        organization.sales_manager_selection,
      );
    }
  }

  handleSubmit (data) {
    const { organization } = this.props;
    const params = {
      annual_sales_goals: data.annual_sales_goals,
      sales_manager_selection: data.sales_manager_selection,
    };
    return this.props.dispatch(
      requestUpdateOrganization(organization._id, params),
    );
  }

  selectSalesGoals (v) {
    this.props.change('annual_sales_goals', v);
  }

  selectSalesManagerSelection (v) {
    this.props.change('sales_manager_selection', v);
  }

  renderForm () {
    const {
      handleSubmit,
      submitting,
      selectedSalesGoals,
      selectedSalesManager,
    } = this.props;

    const options = [
      { value: true, label: 'Enable annual sales goals' },
      { value: false, label: 'Disable annual sales goals' },
    ];

    const salesManagerSelectionOptions = [
      { value: true, label: 'Enable sales manager selection' },
      { value: false, label: 'Disable sales manager selection' },
    ];

    const selectedOption = find(options, { value: selectedSalesGoals });
    const selectedSMSOption = find(salesManagerSelectionOptions, {
      value: selectedSalesManager,
    });
    const cursor = submitting ? 'not-allowed' : 'pointer';

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className='panel panel-default'>
          <div className='panel-heading'>
            Key Sales Settings for Sales Reps &#38; Sales Management
          </div>

          <div className='panel-body' style={{ display: 'flex' }}>
            <FormGroup className={styles.leftTable}>
                <ControlLabel>Annual Sales Goals Setting:</ControlLabel>
                <table className='table table-condensed table-borderless'>
                  <tbody>
                    {options.map((opt) => {
                      const isChecked =
                        selectedOption !== undefined &&
                        opt.value === selectedOption.value;
                      let cls = isChecked ? 'text-success' : '';
                      let faName = isChecked ? 'check-circle' : 'circle-o';
                      let spin = false;
                      if (submitting) {
                        spin = true;
                        cls = 'text-muted';
                        if (isChecked) {
                          faName = 'spinner';
                        }
                      }
                      return (
                        <tr
                          style={{ cursor }}
                          key={opt.value}
                          onClick={() => {
                            if (!submitting) {
                              this.selectSalesGoals(opt.value);
                            }
                          }}>
                          <td style={{ width: 20 }}>
                            <Fa name={faName} className={cls} spin={spin} />
                          </td>
                          <td>
                            <ControlLabel style={{ cursor }}>
                              <strong>{opt.label}</strong>
                            </ControlLabel>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </FormGroup>
              <FormGroup>
                <ControlLabel>
                  Force Sales Manager Selection for Sales Reps:
                </ControlLabel>
                <table className='table table-condensed table-borderless'>
                  <tbody>
                    {salesManagerSelectionOptions.map((opt) => {
                      const isChecked =
                        selectedSMSOption !== undefined &&
                        opt.value === selectedSMSOption.value;
                      let cls = isChecked ? 'text-success' : '';
                      let faName = isChecked ? 'check-circle' : 'circle-o';
                      let spin = false;
                      if (submitting) {
                        spin = true;
                        cls = 'text-muted';
                        if (isChecked) {
                          faName = 'spinner';
                        }
                      }
                      return (
                        <tr
                          style={{ cursor }}
                          key={opt.value}
                          onClick={() => {
                            if (!submitting) {
                              this.selectSalesManagerSelection(opt.value);
                            }
                          }}>
                          <td style={{ width: 20 }}>
                            <Fa name={faName} className={cls} spin={spin} />
                          </td>
                          <td>
                            <ControlLabel style={{ cursor }}>
                              <strong>{opt.label}</strong>
                            </ControlLabel>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
            </FormGroup>
          </div>
          <div className='panel-footer text-right'>
            <Button disabled={submitting} bsStyle='primary' type='submit'>
              Update Settings
            </Button>
          </div>
        </div>

        <div style={{ height: 200 }} />
      </form>
    );
  }

  render () {
    return (
      <div>
        <Helmet title='Sales Management | Organization Setup' />
        <div className='container'>{this.renderForm()}</div>
      </div>
    );
  }
}

const selector = formValueSelector('organizationSaleaGoalsForm'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps (state) {
  const formState = getFormValues('organizationSaleaGoalsForm')(state);
  console.log('formState...', formState);
  const selectedSM = selector(state, 'sales_manager_selection');
  console.log('selectedSM...', selectedSM);
  return {
    user: getUser(state),
    organization: getUserCurrentOrganization(state),
    selectedSalesGoals: selector(state, 'annual_sales_goals') || false,
    selectedSalesManager: selector(state, 'sales_manager_selection'),
  };
}

SalesGoalsPage.propTypes = {
  user: PropTypes.object.isRequired,
  organization: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  change: PropTypes.func,
  selectedSalesGoals: PropTypes.bool,
  selectedSalesManager: PropTypes.bool,
};

SalesGoalsPage.defaultProps = {
  selectedSalesGoals: null,
  selectedSalesManager: null,
};

SalesGoalsPage.contextTypes = {
  router: PropTypes.object,
};

const OrganizationGDPRForm = reduxForm({
  form: 'organizationSaleaGoalsForm',
})(SalesGoalsPage);

export default connect(mapStateToProps)(OrganizationGDPRForm);
